/** Shared queue names and repair destinations; optional quality is never a publish gate. */
export const QUALITY_QUEUES = [
  { id: "MISSING_WEIGHT", label: "Missing shipping weight", section: "shipping" },
  { id: "MISSING_FIT", label: "Missing fit details", section: "attributes" },
  { id: "MISSING_DESCRIPTION", label: "Missing description", section: "general" },
  { id: "PHOTO_COVERAGE", label: "Photo coverage", section: "general" },
  { id: "AMBIGUOUS_COLOUR", label: "Check colour labels", section: "attributes" },
] as const;
export const CATALOG_READINESS_VALUES = ["images-needed", "ready-to-publish", "MISSING_COST", ...QUALITY_QUEUES.map((q) => q.id)] as const;
export type CatalogReadiness = typeof CATALOG_READINESS_VALUES[number];
export function qualityRepairSection(queue: string) {
  return QUALITY_QUEUES.find((q) => q.id === queue)?.section ?? (queue === "images-needed" ? "general" : "general");
}
export function safeCatalogueReturn(value?: string) {
  return value && /^\/admin\/catalog\/products(?:\?[^\\#]*)?$/.test(value) ? value : "/admin/catalog/products";
}
